export const data = state => state.data
export const style = state => state.style
export const metadata = state => state.metadata
export const currentBorderWidth = state => state.currentBorderWidth
export const currentBorderColor = state => state.currentBorderColor
export const typeDonnees = state => state.typeDonnees
export const projectsList = state => state.projectsList
export const tableauxList = state => state.tableauxList
export const disabledAddTableau = state => state.disabledAddTableau
export const espacesList = state => state.espacesList
export const tableauDataById = state => state.tableauDataById
export const currentProject = state => state.currentProject
export const currentOnglet = state => state.currentOnglet
export const showType = state => state.showType
export const listOnglet = state => state.listOnglet
export const getPermissions = state => state.getPermissions
export const setFiches = state => state.setFiches
export const isCopied = state => state.isCopied

export const isProjectTemplate = state => state.isProjectTemplate
export const isCloningFormat = state => state.isCloningFormat
export const isSelectingColor = state => state.isSelectingColor



// WEBPACK FOOTER //
// ./src/store/modules/tableau/getters.js